import { stringifyObjectValuesShallow, trackHeapEvent } from '@ratehub/base-ui';


/**
 * 'Loan redirect to partner'-specific call for `trackHeapEvent`.
 *
 * @param {Object} params - the parameters for the event
 * @param {string} params.referrerURL - the URL of the referrer
 * @param {string} params.affiliateId - the ID of the affiliate
 * @param {Object} params.additionalInfo - additional information for the event
 * @param {Object} params.loan - the loan
 * @param {string} loan.provider.name - the loan’s provider name
 * @param {Object} loan.giftOffer - the gift offer for the loan
 * @param {boolean} loan.isMonetized - is the loan monetized?
 * @param {boolean} loan.isSponsored - is the loan sponsored?
 */
function trackHeapLoanRedirectEvent({ referrerURL, affiliateId, additionalInfo, loan }) {
    const {
        slug,
        provider,
        applyURL,
        giftOffer,
        isMonetized,
        isSponsored,
    } = loan;

    trackHeapEvent('Loan redirect to partner', {
        slug,
        provider: provider.name,
        href: applyURL,
        monetized: isMonetized.toString(),
        sponsored: isSponsored.toString(),
        ...(referrerURL && { refererUrl: referrerURL }),
        // refererUrl [sic] - preserve typo in property name
        ...(affiliateId && { affiliateId }),

        // simplify analytic’s tracking efforts by passing only string values to Heap
        ...stringifyObjectValuesShallow(giftOffer),
        ...stringifyObjectValuesShallow(additionalInfo),
    });
}


export default trackHeapLoanRedirectEvent;
